import { createApp } from 'vue'
import App from '@/App.vue'
import router from '@/router'
import pinia from './stores'
import { useRootStore } from './stores/store'
import { mapStores } from 'pinia'
import { EventBus, Events } from '@/eventbus/EventBus'
import './eventbus/EventHandler'
import './sass/styles.scss'

import axios from 'axios'

import RotatingSpinner from '@/components/ui/RotatingSpinner.vue'
import BouncingSpinner from '@/components/ui/BouncingSpinner.vue'
import AuthorizationComponent from '@/components/AuthorizationComponent.vue'
import PopupMenu from '@/components/ui/PopupMenu.vue'
import MenuItem from '@/components/ui/MenuItem.vue'
import CloseButton from '@/components/ui/CloseButton.vue'
import SelectBox from '@/components/ui/SelectBox.vue'
import CardHolder from '@/features/printstore/children/CardHolder.vue'

import VModal from '@febe95/vue-js-modal'
import uploader from 'vue-simple-uploader'
import Vuelidate from '@vuelidate/core'

import InlineSvg from 'vue-inline-svg'

import { createGtm } from '@gtm-support/vue-gtm'
import { createHead, VueHeadMixin } from '@unhead/vue/client'

import clickOutside from './directives/clickOutside'

const app = createApp(App)
const head = createHead()

app.use(router)
app.use(pinia)
app.use(uploader)
app.use(Vuelidate)
app.use(VModal)
app.use(head)
app.mixin(VueHeadMixin)

app.mixin({
  computed: {
    ...mapStores(useRootStore)
  }
})

app.use(
  createGtm({
    id: 'GTM-T7PX3D39',
    enabled: cookiesAllowed(),
    vueRouter: router,
    trackOnNextTick: true,
    nonce: 'c96c718b-bef8-4770-a056-eab5efaac9af' // For use with CSP policy
  })
)

app.component('CardHolder', CardHolder)
app.component('authorization-component', AuthorizationComponent)
app.component('popup-menu', PopupMenu)
app.component('menu-item', MenuItem)
app.component('close-button', CloseButton)
app.component('select-box', SelectBox)
app.component('bouncing-spinner', BouncingSpinner)
app.component('rotating-spinner', RotatingSpinner)
app.component('inline-svg', InlineSvg)

app.directive('click-outside', clickOutside)

import { format, parseISO } from 'date-fns'
import { cookiesAllowed } from './api/Cookies'

app.config.globalProperties.$filters = {
  capitalize(value) {
    if (!value || typeof value !== 'string') return
    return value.toUpperCase()
  },
  formatDate(value) {
    return value ? format(parseISO(value), 'dd-MM-yyyy') : ''
  },
  formatTime(value) {
    return value ? format(parseISO(value), 'HH:mm') : ''
  },
  formatFileSize(value) {
    if (typeof value !== 'number') return
    if (value === 0) return '0 B'
    const units = ['B', 'kB', 'MB', 'GB', 'TB']
    const exponent = Math.min(
      Math.floor(Math.log(value) / Math.log(1024)),
      units.length - 1
    )
    return (value / Math.pow(1024, exponent)).toFixed(1) + ' ' + units[exponent]
  }
}

axios.defaults.withCredentials = true

axios.interceptors.response.use(
  (response) => response,
  (error) => {
    if (error.response?.status === 401) {
      EventBus.emit(Events.REQUEST_LOGIN, error.response.data)
    }
    return Promise.reject(error)
  }
)

app.mount('#app')

// Debug voor unhandled promise rejections
window.onunhandledrejection = function (event) {
  console.error(`Unhandled Rejection: ${event.reason}`)
}
